import React from 'react';
import {Alert} from "antd";


const parseMessage = (message) => {

    if (!message) {
        return
    }

    if (typeof message == 'string') {
        return message;
    }

    if (Array.isArray(message)) {
        return parseArray((message))
    }

    if (typeof message === 'object') {
        return parseObject(message)
    }

    return message;

}

const parseArray = (messages) => {
    return messages.map(message => {
        message = parseMessage(message)
        return message
    });
};

const parseObject = (messages) => {
    return Object.keys(messages).map(key => {
        return <ErrorItem field={key} label={messages[key]}/>
    });
};


const ErrorItem = ({field, label}) => {

    if (!field || field === 'non_field_errors' || field === 'detail') {
        return <span> {label}</span>
    }

    field = field.replace(/_/g, ' ');

    return (
        <span>
            <span style={{fontSize: '300'}}>{field}</span> : {label} &nbsp;
        </span>)
}

const ErrorRender = ({error}) => {

    if (!error.response) {

        return <Alert message={error.message} type="error" showIcon/>
    }

    if (error.response.status === 400) {

        const items = Object.keys(error.response.data).map(key => {

            const message = parseMessage(error.response.data[key]);

            return (
                <li style={{listStyleType: 'none'}} key={key}>
                    <ErrorItem field={key} label={message}/>
                </li>
            );
        });

        return <Alert message={<ul style={{margin: 0, padding: 0}}>{items}</ul>} type="error" showIcon/>;
    }

    if (error.response.status === 401) {
        return <Alert message="Not Authorized" type="error" showIcon/>;
    }

    if (error.response.status === 403) {
        return <Alert message="Access denied" type="error" showIcon/>;
    }

    if (error.response.status === 404) {
        return <Alert message="Not found" type="error" showIcon/>;
    }

    if (error.response.data.detail) {
        return <Alert message={error.response.data.detail} type="error"
                      showIcon/>;
    }

    return null;


};

export default ErrorRender;
